// Framework
import * as Api from 'api/login';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import Raven from 'raven-js';
import { formComplete } from 'actions/auth/auth';
import { pushFormattedError } from 'helpers/formValidationHelper/formValidationMessage';

// Selectors
const getLocale = (state) => state.i18nState.lang;

// Actions
export const PASSWORDRESET = 'AUTH/PASSWORDRESET';
export const PASSWORDRESET_SUCCESS = 'AUTH/PASSWORDREST_SUCCESS';
export const PASSWORDRESET_ERROR = 'AUTH/PASSWORDRESET_ERROR';

/*** Action Creators ***/
export const passwordReset = (action) => ({
  type: PASSWORDRESET,
  action
});

export const passwordResetSuccess = (response) => ({
  type: PASSWORDRESET_SUCCESS,
  response
});

export const passwordResetError = (error) => ({
  type: PASSWORDRESET_ERROR,
  error: error
});

/*** Reducer ***/
export const DEFAULT_STATE = {};

export default function passwordResetReducer(
  state = DEFAULT_STATE,
  { response, error, type } = {}
) {
  switch (type) {
    case PASSWORDRESET_ERROR:
      Raven.captureException(error, { state });
      return {
        ...state,
        error
      };
    case PASSWORDRESET_SUCCESS:
      return {
        ...state,
        response
      };
    case PASSWORDRESET:
    default:
      return state;
  }
}

/*** Sagas ***/
// Worker
function* initializeAsyncPasswordResetWorker({ action: { email } }) {
  const locale = yield select(getLocale);

  try {
    const headers = {
      Accept: 'application/vnd.novus+json; version=1',
      'Accept-Language': locale,
      'Content-Type': 'application/json'
    };
    const body = {
      auth_adapter: 'novus',
      // replace with site.data.consumer
      consumer: 'NovusGeneric',
      email
    };
    yield call(Api.reset, headers, body, { email });
    yield put(passwordResetSuccess());
    yield put(formComplete());
  } catch (err) {
    yield pushFormattedError(err);
    yield put(passwordResetError(err.messages[0]));
  }
}

// Watcher
export function* passwordResetSaga() {
  yield takeEvery(PASSWORDRESET, initializeAsyncPasswordResetWorker);
}



// WEBPACK FOOTER //
// ./src/actions/auth/password.js